/**
 * The disable and enable scroll needs an css entry to work correctly
 * body {
 *      overflow: hidden;
 *      position: fixed;
 *      width: 100%;
 *      padding-right: var(--scrollbar-width-x);
 *  }
 */

// import {
// 	disableBodyScroll,
// 	enableBodyScroll,
// 	clearAllBodyScrollLocks,
// } from 'body-scroll-lock-upgrade'

import { lock, unlock } from 'tua-body-scroll-lock'

export default class Browser {
	constructor(options) {
		this.scrollbarWidth = this.fetchScrollbarWidth()
		this.root = document.documentElement
		this.body = document.body
		this.storedY = undefined
		this.init()
	}

	fetchScrollbarWidth() {
		return window.innerWidth - document.body.offsetWidth
	}
	storeScrollbarWidth() {
		let width = this.fetchScrollbarWidth()
		this.root.style.setProperty('--scrollbar-width-x', width + 'px')
	}
	init() {
		this.storeScrollbarWidth()
	}
	// public
	disableScroll(el) {
		this.storedY = window.scrollY
		this.root.classList.add('no-scroll-fixed')

		if (window.app.lenis) {
			window.app.lenis.stop()
		} else {
			lock(el, { overflowType: 'clip' })
		}

		// disableBodyScroll(el, { reserveScrollBarGap: true })

		// if (this.isIOSSafari() && supportsOverflowClip()) {
		// 	document.body.style.overflow = 'clip'
		// } else {
		// 	disableBodyScroll(el, { reserveScrollBarGap: true })

		// 	// document.body.style.overflow = 'hidden' // or use body-scroll-lock fallback
		// }
	}
	enableScroll(restoreScrollPos = true) {
		// clearAllBodyScrollLocks()
		this.root.classList.remove('no-scroll-fixed')

		if (window.app.lenis) {
			window.app.lenis.start()
		} else {
			unlock()

			// restore the scroll position
			if (restoreScrollPos) {
				window.scrollTo({
					top: this.storedY,
					left: 0,
					behavior: 'instant',
				})
			}
		}
	}
	isIOSSafari() {
		return (
			/iP(ad|hone|od)/.test(navigator.userAgent) &&
			/WebKit/.test(navigator.userAgent) &&
			!/CriOS|FxiOS|OPiOS/.test(navigator.userAgent)
		)
	}
	supportsOverflowClip() {
		return CSS.supports('overflow', 'clip')
	}
}

/**
 * let BodyScroll = () => {
  let body = document.body
  let scrollBarWidth = window.innerWidth - body.offsetWidth
  //console.log(scrollBarWidth)
  let root = document.documentElement
  root.style.setProperty('--scrollbar-width-x', scrollBarWidth + 'px')

  let noscroll = () => {
    body.classList.add('no-scroll-fixed')
    // body.style.position = 'fixed'
    // body.style.left = '0'
    // body.style.right = scrollBarWidth + 'px'

    //body.style.width = '100%'
    // body.style.paddingRight = scrollBarWidth + 'px'
  }
  let restoreScroll = () => {
    body.classList.remove('no-scroll-fixed')

    // body.classList.add('is-fixed');
    // body.style.position = 'fixed'
    // body.style.left = '0'
    // body.style.right = scrollBarWidth + 'px'
    // body.style.position = 'relative'
    // body.style.width = 'auto'
    // console.log('unfix')
  }
  return {
    noscroll: noscroll,
    restoreScroll: restoreScroll
  }
}
 */
